<template>
  <div class="excercise-layout">
    <TopNavbar />

    <header class="bg-primary text-white text-center py-5 practica-header">
      <h2 class="h4">Examen</h2>
      <img
        class="mt-3"
        style="border: solid 2px #fff; border-radius: 7px"
        src="../assets/images/icons/trigonometry.svg"
        alt="Trigonometría"
      />
      <h1 class="h3 mt-3">{{ currentQuestion && currentQuestion.category }}</h1>
    </header>

    <main class="container mt-n5" v-if="currentQuestion">

      <div class="row">
        <!-- Question container -->
        <div class="col-12 col-md-8">
          <div class="card px-3 py-3 px-md-5 py-md-5 position-relative">
            <!-- Hint button -->
            <div class="hint-container" :class="{ active: showHint }" v-if="getHint() !== ''">
              <button class="hint-button" @click="toggleHint">
                <div class="inner-content">
                  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7.032 18.951l5.795 1.553-.518 1.932-5.795-1.553.518-1.932zm9.264-4.027c1.307-.899 2.657-1.828 3.242-4.01.999-3.728-1.222-7.574-4.95-8.573-3.727-.999-7.574 1.222-8.573 4.95-.591 2.207.117 3.684.805 5.112.238.497.484 1.01.698 1.584.086.236.11 1.06.074 2.008l-.75-.2-.517 1.931 7.727 2.07.518-1.931-.748-.2c.446-.84.88-1.544 1.071-1.706.47-.395.944-.72 1.403-1.035zm-2.687-.5c-.579.484-1.306 1.799-1.767 2.71l-2.271-.608c.057-1.022.085-2.528-.18-3.237a20.501 20.501 0 00-.769-1.75c-.647-1.348-1.075-2.24-.675-3.73a5.006 5.006 0 016.123-3.536 5.006 5.006 0 013.536 6.123c-.394 1.47-1.21 2.03-2.443 2.88-.474.326-1.01.694-1.554 1.148z"/>
                  </svg>
                  <span>¿Necesitas ayuda?</span>
                </div>
              </button>
              <div  v-if="showHint" class="mt-3">
                <p id="hint">  {{ getHint() }}</p>
              </div>
            </div>

            <!-- Question sentence -->
            <div style="max-width: 100%; margin: auto">
              <p id="question">{{ currentQuestion.description }}</p>
              <p class="text-center" >
                <img
                  v-if="currentQuestion.graph"
                  :src="getGraphUrl(currentQuestion.graph)"
                  alt="imagen1"
                  class="mt-3 mb-5"
                  style="max-width: 100%"
                />
                <img
                  v-if="currentQuestion.graphUrl"
                  :src="currentQuestion.graphUrl"
                  alt="imagen2"
                  class="mt-3 mb-5"
                  style="max-width: 100%"
                />
              </p>
            </div>
            <!-- End Question sentence -->

            <!-- Question Form-->
            <form id="quetions-form" style="max-width: 500px; margin: auto">
              <div class="mb-3">
                <div
                  class="question-option"
                  v-for="(option, index) in currentQuestion.answers"
                  :key="index"
                >
                  <label
                    class="d-flex flex-row justify-content-between mb-0 py-2 px-2 px-md-4"
                    :for="'question-option-' + index"
                  >
                    <div class="d-flex flex-column">
                      <div>
                        <input
                          name="question-option"
                          class="mr-2"
                          type="radio"
                          v-model="selectedOption"
                          :id="'question-option-' + index"
                          :value="index"
                        />
                        <span :id="'answer-option-' + index">{{ option.description }} </span>
                      </div>
                      <img v-if="option.graphUrl" :src="option.graphUrl" alt="" class="mt-1 rounded" style="max-width: 140px;" />
                    </div>
                    <div>
                      <span v-if="selectedOption === index">&nbsp;Seleccionada</span>
                    </div>
                  </label>
                </div>
              </div>
              <div>
                <button
                  id="anterior"
                  type="button"
                  class="btn ml-md-2"
                  :class="{
                    'btn-disabled': counter === 0,
                  }"
                  @click="goPreviousQuestion"
                  :disabled="counter === 0"
                >
                  Anterior
                </button>
                <button
                  id="siguiente"
                  type="button"
                  class="btn ml-md-2"
                  @click="nextQuestion"
                  :hidden=" this.counter + 1 >= this.questions.length"
                >
                  Siguiente
                </button>
              </div>

              <b-modal no-close-on-backdrop ref="alert-modal" hide-footer data-backdrop="static" data-keyboard="false"> <p>Tiempo finalizado</p>

              <div class="row" >
                <div class="col col-sm-6 col-md-6 col-lg-6 text-center">

                  </div>

                  <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                    <b-button class="mt-3" variant="outline-danger" block @click="this.goToResults">Continuar</b-button>
                  </div>
                </div>

              </b-modal>

              <b-modal ref="alert-modal-2" hide-footer hide-header > <p>¡Hay preguntas sin resolver!</p>
                <div class="row" >
                  <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                    <b-button class="mt-3" variant="outline-success" block @click="this.closeModalResults">Revisar</b-button>
                  </div>
                  <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                    <b-button class="mt-3" variant="outline-danger" block @click="this.goToResults">Enviar de todos modos</b-button>
                  </div>
                </div>
              </b-modal>

              <b-modal ref="alert-modal-3" hide-footer hide-header > <p>Aún tienes tiempo para revisar tu examen</p>
                <div class="row" >
                  <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                    <b-button class="mt-3" variant="outline-success" block @click="this.closeModalwarning">Revisar</b-button>
                  </div>
                  <div class="col col-sm-6 col-md-6 col-lg-6 text-center">
                    <b-button class="mt-3" variant="outline-danger" block @click="this.goToResults">Enviar de todos modos</b-button>
                  </div>
                </div>
              </b-modal>
              
            </form>
            <!-- End Question Form-->

          </div>
        </div>
        <!-- End Question container -->

        <!-- Sidebar -->
        <div class="col-12 col-md-4">
          <div class="card">
            <div>
              <p class="font-weight-bold mb-2">Dificultad</p>
              <div class="d-flex align-items-center">
                <img src="../assets/images/icons/dificultad.svg" alt="" />
                <p class="font-weight-light m-0 ml-2">
                  {{ currentQuestion.difficulty.description }}
                </p>
              </div>
            </div>
            <div class="mt-3">
              <p class="font-weight-bold mb-2">Área de conocimiento</p>
              <div class="d-flex align-items-center">
                <img src="../assets/images/icons/conocimiento.svg" alt="" />
                <p class="font-weight-light m-0 ml-2">
                  {{ currentQuestion.category }}
                </p>
              </div>
            </div>
            <div class="mt-3">
              <p class="font-weight-bold mb-2">Tipos de pensamiento</p>
              <div class="d-flex align-items-center">
                <img src="../assets/images/icons/pensamientos.svg" alt="" />
                <p class="font-weight-light m-0 ml-2">
                  {{ currentQuestion.knowledge_area.description }}
                </p>
              </div>
            </div>
          </div>
          <div class="card">
            <p>
              Ejercicio <span>{{ counter + 1 }}/{{ questions.length }}</span>
            </p>
            <div class="progress-bar">
              <div
                class="progress-bar-inner progress-bar-blue"
                :style="{ width: progressBarPercentage + '%' }"
              ></div>
            </div>
          </div>
          <div class="card">
            <div class="row ml-2">
              <div class="w-22 mt-2" v-for="(question, index) in questions"  :key="index">
                <button type="button" class="btn btn-square-md text-center mr-1" style="width: 48px; padding: 14px 5px;" :class="{ 'bg-color-red': question.selectedOption == null, 'bg-color-green' : question.selectedOption != null}" @click="goToQuestion(index)">{{index + 1}}</button>
              </div>
            </div>
          </div>
          <div class="card">
            <button class="btn btn-primary w-100" @click="checkGoToResults">
              Enviar todo y terminar
            </button>
          </div>
          <p  class="text-gray-600 font-italic " style="font-size: 12px">{{this.currentQuestion.uniqueName}}</p>
        </div>
      </div>
      <!-- End Sidebar -->
    </main>
    <TimeRemain  :timeRemain="finishAt" @alertFinish="alertFinish" v-if="finishAt"/>
  </div>

</template>

<script>
import axios from "axios";
import TopNavbar from "@/components/TopNavbar.vue";
import TimeRemain from "@/components/TimeRemain.vue";
import assetImport from "../Utils/asset-import";

export default {
  name: "Exercise",
  props: ["topic"],
  components: {
    TimeRemain,
    TopNavbar,
  },
  data: () => {
    return {
      currentQuestion: null,
      questions: null,
      finishAt: null,
      selectedOption: null,
      counter: 0,
      attempts: null,
      correctAnswers: 0,
      answered: false,
      simulacrumData: {},
      isReview: false,
      firstLoad: true,
      showHint: false,
      finished: false,
    };
  },
  methods: {
    alertFinish() {
      this.closeModalResults();
      this.closeModalwarning();

      setTimeout(this.goToResults,10000);
      this.finished = true;
      this.$root.$emit('bv::show::modal', 'alert-modal', '#btnShow')
    },
    showModal() {
      // this.selectedSimulacrum = simulacrum
      this.$refs['alert-modal'].show()
    },
    closeModalResults() {
      this.$refs['alert-modal-2'].hide()
    },
    closeModalwarning() {
      this.$refs['alert-modal-3'].hide()
    },
    getHint: function(){
      if (this.currentQuestion) {
        return this.currentQuestion.hint;
      }
    },
    getQuestionDescription: function(question){
      const elements = document.getElementById("question");
      if(elements){
        elements.innerText = question;
      } else {
        return question;
      }
    },
    getQuestionSolution: function(solution){
      const elements = document.getElementById("solution");
      if(elements){
        elements.innerText = solution;
      } else {
        return solution;
      }
    },
    nextQuestion: function () {
      this.counter++;
      this.showHint = false;
      this.currentQuestion = null;
      this.$nextTick(function () {
        this.selectedOption = null;
        this.setQuestion(
          this.questions.find(
            (question) => question.position === this.counter + 1
          )
        );
        this.getUserAttempts();
      });
    },
    goToQuestion: function (index) {
      this.counter = index;
      this.showHint = false;
      this.currentQuestion = null;
      this.$nextTick(function () {
        this.selectedOption = null;
        this.setQuestion(
          this.questions.find(
            (question) => question.position === this.counter + 1
          )
        );
        this.getUserAttempts();
      });
    },
    goPreviousQuestion() {
      this.counter--;
      this.currentQuestion = null;
      this.$nextTick(function () {
        this.selectedOption = null;
        this.setQuestion(
          this.questions.find(
            (question) => question.position === this.counter + 1
          )
        );
        this.getUserAttempts();

      });
    },
    loadSimulacrumData() {
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL +
          "/api/simulacrums/getByTopic/" +
          this.topic,
          {
            params: {},
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.simulacrumData = response.data;
          this.finishAt =  this.simulacrumData.simulacrumRegistry.finishAt;
        });
    },
    loadExercises() {
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL +
          "/api/question/getBySimulacrum/" +
          this.topic,
          {
            params: {},
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          this.questions = response.data;
          this.questions = this.questions.sort((a, b) =>  a.position - b.position);
          if (this.counter >= response.data.length) {
            this.counter = response.data.length - 1;
          }
          this.$nextTick(function () {
            this.attempts.forEach((attempt) => {
              this.questions.forEach((question) => {
                if (attempt.question.id === question.id)
                  question.selectedOption = attempt.answer.position - 1;
              });
            });
            this.$nextTick(function () {
              if (!this.isReview || this.firstLoad) {
                this.setQuestion(
                  response.data.find(
                    (question) => question.position === this.counter + 1
                  )
                );
              }});
          });
        });
    },
    getGraphUrl(graphName) {
      if (graphName === "NaN") return "";
      try {
        return assetImport("../assets/images/graphs/" + graphName + ".svg");
      } catch (e) {
        console.log("Gráfica no encontrada: " + graphName)
        return "";
      }
    },
    getUserAttempts() {
      let loader = this.$loading.show({});
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/attempts/getCurrentQuestion",
          {
            params: { simulacrumKey: this.topic },
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          loader.hide();
          this.attempts = response.data;
          console.log(response);
          if (this.firstLoad) {
            this.counter = response.data.length;
            this.firstLoad = false;
            this.$nextTick(function () {
              this.loadExercises();
            });
          } else {
            this.questions.forEach((question) => {
              question.selectedOption = null;
            });
            this.attempts.forEach((attempt) => {
              this.questions.forEach((question) => {
                if (attempt.question.id === question.id)
                  question.selectedOption = attempt.answer.position - 1;
              });
            });
          }
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    setQuestion(excercice) {
      let loader = this.$loading.show({});
      axios
        .get(
          import.meta.env.VITE_API_BASE_URL + "/api/question/" + excercice.id,
          {
            headers: {
              Authorization: "Bearer " + localStorage.getItem("token"),
            },
          }
        )
        .then((response) => {
          excercice.answers = response.data.answers;
          excercice.description = response.data.description;
          excercice.uniqueName = response.data.uniqueName;
          excercice.difficulty = response.data.difficulty;
          excercice.category = response.data.category;
          excercice.solution = response.data.solution;
          excercice.hint = response.data.hint;
          excercice.knowledge_area = response.data.knowledge_area;
          excercice.graph = response.data.graph;
          excercice.graphUrl = response.data.graphUrl;
          excercice.answers.sort(function (a, b) {
            return parseInt(a.position) - parseInt(b.position);
          });
          if (excercice.selectedOption != null) {
            this.selectedOption = excercice.selectedOption;
            this.answered = true;
            this.isReview = true;
          } else {
            this.isReview = false;
            this.answered = false;
          }

          this.$nextTick(function () {
            this.currentQuestion = excercice;
            setTimeout(function(){
              loader.hide();
            }, 200);
          });
        })
        .catch((err) => {
          console.log(err.message);
          loader.hide();
        });
    },
    checkResponse: function () {
      if (this.finished) {
        return;
      }
      this.answered = true;
      const params = new URLSearchParams();
      params.append("categoryId", this.topic);
      params.append(
        "answerId",
        this.currentQuestion.answers[this.selectedOption].id
      );
      axios
        .post(import.meta.env.VITE_API_BASE_URL + "/api/attempts/", params, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          let indexQues = this.questions.findIndex(quest => quest.id === this.currentQuestion.id)
          this.$nextTick(function () {
            this.updateSelectedOption(indexQues);
          });
          console.log(response);
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    updateSelectedOption(indexQues) {
      var vm = this;
      this.questions = [...this.questions.slice(0, indexQues), { ...this.questions[indexQues], selectedOption: vm.selectedOption}, ...this.questions.slice(indexQues + 1)];

    },
    checkGoToResults() {
      let allResolved = true;

      this.questions.forEach(question => {
        if (question.selectedOption == null) {
          allResolved = false
        }
      })
      if (!allResolved) {
        this.$refs['alert-modal-2'].show()
      } else {
        this.$refs['alert-modal-3'].show()
      };
    },
    goToResults() {
      axios
        .post(import.meta.env.VITE_API_BASE_URL + "/api/simulacrums/setResolved", {simulacrumId: this.simulacrumData.id}, {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        })
        .then((response) => {
          console.log(response);
          this.$router.replace({
            path: `/simulacrumresult/${this.simulacrumData.id}`,
          });
        })
        .catch((err) => {
          console.log(err.message);
        });
    },
    toggleHint() {
      this.showHint = !this.showHint;
    },
  },
  watch: {
    finished: function() {
      if (this.finished) {
        this.showModal();
      }
    },
    currentQuestion: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    showHint: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    questions: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    answered: function () {
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    },
    selectedOption: function() {
      this.checkResponse();
      if ('MathJax' in window) {
        this.$nextTick(function() {
          window.MathJax.Hub.Queue(["Typeset", window.MathJax.Hub]);
        });
      }
    }
  },
  computed: {
    progressBarPercentage: function () {
      return ((this.counter + 1) * 100) / this.questions.length;
    },

  },
  beforeMount() {
    this.getUserAttempts();
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  },
  mounted() {
    this.loadSimulacrumData();
  },
};
</script>

<style src="@/assets/css/app.css"></style>
